import { useState } from 'react';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { Navigate, useNavigate } from 'react-router-dom';
import { Logo } from '../../app/shell/Sidebar';
import { Field, Spinner } from '../../components/ui';
import { ApiError } from '../../lib/api';
import { useSession } from '../../lib/session';

export function SuperLoginPage() {
  const { t } = useTranslation();
  const nav = useNavigate();
  const { status, realm, loginSuper } = useSession();
  const [error, setError] = useState<string | null>(null);
  const form = useForm<{ email: string; password: string }>({ defaultValues: { email: '', password: '' } });

  if (status === 'authenticated' && realm === 'super') return <Navigate to="/admin/tenants" replace />;

  const onSubmit = form.handleSubmit(async (dto) => {
    setError(null);
    try {
      await loginSuper(dto.email, dto.password);
      nav('/admin/tenants', { replace: true });
    } catch (e) {
      setError(e instanceof ApiError ? e.localized : t('common.error'));
    }
  });

  return (
    <main className="flex min-h-dvh flex-col items-center justify-center bg-[#0b1a12] p-6">
      <div className="mb-6">
        <Logo />
      </div>
      <form onSubmit={onSubmit} className="card w-full max-w-md p-6 sm:p-8" noValidate>
        <h1 className="mb-1 text-xl font-bold">{t('admin.loginTitle')}</h1>
        <p className="mb-6 text-sm text-text-muted">{t('admin.loginSubtitle')}</p>
        <div className="flex flex-col gap-4">
          <Field label={t('login.email')} required>
            {(id) => <input id={id} type="email" dir="ltr" className="input" {...form.register('email', { required: true })} />}
          </Field>
          <Field label={t('login.password')} required>
            {(id) => <input id={id} type="password" dir="ltr" className="input" {...form.register('password', { required: true })} />}
          </Field>
          {error ? (
            <p className="rounded-md bg-danger-bg px-3 py-2 text-sm text-danger-fg" role="alert">
              {error}
            </p>
          ) : null}
          <button type="submit" className="btn-primary min-h-11 w-full" disabled={form.formState.isSubmitting}>
            {form.formState.isSubmitting ? <Spinner /> : null}
            {t('login.submit')}
          </button>
        </div>
      </form>
    </main>
  );
}
